<p-table #dtNoti [value]="this.evaluacioneService.notificaciones()" [columns]="cols" responsiveLayout="scroll" [rows]="10"
         [globalFilterFields]="['numeroNotificacion','usuario','estado']"
         [paginator]="true" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true"
         [styleClass]="'p-datatable-sm'"
         currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} notificaciones"
         selectionMode="multiple" [rowHover]="true" dataKey="id">
    <ng-template pTemplate="caption">
        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">Notifaciones: ({{ this.evaluacioneService.notificaciones().length }})</h5>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>

            <th pSortableColumn="titulo">Título
                <p-sortIcon field="titulo"></p-sortIcon>
            </th>
            <th>
                <p-columnFilter type="text" field="usuario"
                                placeholder="Filtrar por usuario"
                                ariaLabel="Filtrar por usuario" />
            </th>
            <th>
                <p-columnFilter type="text" field="fechaCreacion"
                                placeholder="Filtrar por fecha"
                                ariaLabel="Filtrar por fecha" />
            </th>
            <th>Opción</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-notificaciones>
        <tr>
            <td>
                <span class="p-column-title">Titulo</span>
                {{notificaciones.titulo}}
            </td>
            <td>
                <span class="p-column-title">Usuario</span>
                {{ notificaciones.usuario }}
            </td>
            <td>
                <span class="p-column-title">Fecha</span>
                {{ notificaciones.fechaCreacion }}
            </td>
            <td>
                <p-button icon="pi pi-eye" class="p-button-rounded mr-2"
                          [rounded]="true" [outlined]="true"
                          pTooltip="Ver observaciones emitidas" severity="info"
                          (onClick)="openDialogReadonlyNotificacion(notificaciones)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>

<ng-container *ngIf="this.openDialog">
    <app-notificar-solicitud-obs [openDialog]="this.openDialog" [titleHeader]="'INFORMACIÓN OBSERVACIÓN'" [idSolicitudEval]="idSolicitudEval!" [textReadOnly]="true"
                                 [type]="EvaluacionEstadosControl.Observaciones" [evaluaciones]="this.evaluacioneService.evaluaciones()" [selected]="selected!"
                                 [infoObservacion]="infoObservacion" (onEventEmitterClose)="onDialogClosed($event)"></app-notificar-solicitud-obs>
</ng-container>
